import React from "react";
import BackButton from "../../components/button/BackButton";

const DonationFooter = () => {
  return (
    <div className="absolute ksm:bottom-[8px] kmd:bottom-[20px] z-30 flex items-center justify-between w-[90%] ">
      <BackButton />
      <img
        src="/logo/donation-logo.png"
        alt=""
        className="mt-4 ksm:w-[197px] kmd:w-[300px] klg:w-[400px]  ksm:h-[45px] kmd:h-[80px] klg:h-[120px]"
      />
      <img
        src="/logo/pair-logo.png"
        alt=""
        className=" ksm:h-[45px] kmd:h-[80px] kxl:h-[120px]"
      />
    </div>
  );
};

export default DonationFooter;
